export default "__VITE_ASSET__44ca8e9a__"